import { Box, Typography, useTheme } from '@mui/material'
import type { FC } from 'react'

type Props = {
  box: {
    id: string
    name: string
    x: number
    y: number
    width: number
    height: number
  }
}

/** 画像上に検査箇所の位置と大きさを示す矩形を表示する */
export const BBox: FC<Props> = ({ box }) => {
  const { id, x, y, width, height } = box

  const theme = useTheme()
  return (
    <Box
      key={id}
      sx={{
        userSelect: 'none',
        position: 'absolute',
        border: `2px solid ${theme.palette.action.disabled}`,
        left: `${x * 100}%`,
        top: `${y * 100}%`,
        width: `${width * 100}%`,
        height: `${height * 100}%`,
      }}
      onPointerDown={e => e.stopPropagation()}
    >
      <Typography
        sx={{
          position: 'absolute',
          top: '-20px',
          left: '0',
          backgroundColor: 'action.disabled',
          padding: '2px 4px',
          fontSize: 12,
          borderRadius: '4px',
          textWrap: 'nowrap',
        }}
      >
        {box.name}
      </Typography>
    </Box>
  )
}
